export default "__VITE_ASSET__CKbDymMv__"